import script from "./ProductGuideComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGuideComp.vue?vue&type=script&setup=true&lang=js"

import "./ProductGuideComp.vue?vue&type=style&index=0&id=0c86d878&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c86d878"]])

export default __exports__